import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['card', 'overlay']
  static values = { unlockedTab: String }

  connect() {
    this.element.addEventListener('shown.bs.tab', this.handleTabChange)
    this.hideOverlayIfUnlockedTabActive()
  }

  hideOverlayIfUnlockedTabActive() {
    const activeTab = this.element.querySelector('.nav a.active')

    if (activeTab && activeTab.getAttribute('href') === this.unlockedTabValue) {
      this.cardTarget.classList.remove('blur-lg', 'pe-none')
      this.overlayTarget.classList.add('d-none')
    }
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.tab', this.handleTabChange)
  }

  handleTabChange = (event) => {
    const targetId = event.target.getAttribute('href')

    if (targetId === this.unlockedTabValue) {
      this.cardTarget.classList.remove('blur-lg', 'pe-none')
      this.overlayTarget.classList.add('d-none')
    } else {
      this.cardTarget.classList.add('blur-lg', 'pe-none')
      this.overlayTarget.classList.remove('d-none')
    }
  }
}
